import Home from './views/index/index.vue'
import CategoryPage from './views/categoryPage/index.vue'
// import CategoryPanelContent from './components/CategoryPanelContent.vue'
// import SearchPage from './views/searchPage/index.vue'


export const routes = [
  {path: '',name:'home',components:{
    default: Home
  }},
  // {path: '/searchpage/:keyword',components:{
  //   default: SearchPage
  // }},
  {path: '/category',name:'category',components:{
    default: CategoryPage
  }},
  {path:'*',redirect:{name:'home'}}
]